import { useCallback, useState } from 'react';
import money from 'shared/utils/Money';
import { AgButton, AgModal, AgModalActions, AgModalContent, AgMoneyInput, AgText } from 'src/components/ui';
import { useBulkUpdateProductCostBasis } from '../hooks/useBulkUpdateProductCostBasis';

type BulkEditCostBasisProps = { selectedRows: any[]; afterSubmit?: (ids: number[], costBasis: number) => void };

export default function BulkEditCostBasis({ selectedRows, afterSubmit }: BulkEditCostBasisProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(0);
  const { bulkUpdate } = useBulkUpdateProductCostBasis();

  const onSubmit = useCallback(() => {
    const ids = selectedRows.map((row) => row.productId ?? row.id);
    const cents = money.toCents(editValue);

    bulkUpdate({ ids, costBasis: cents });
    afterSubmit?.(ids, cents);
  }, [bulkUpdate, selectedRows, editValue, afterSubmit]);

  return (
    <>
      <AgButton variant="white" isDisabled={!selectedRows.length} onPress={() => setIsEditing(true)}>
        Bulk Edit Cost Basis {selectedRows.length ? `(${selectedRows.length})` : ''}
      </AgButton>
      {isEditing && (
        <AgModal
          open
          onClose={() => setIsEditing(false)}
          title={`Editing cost basis for ${selectedRows.length} products`}
          size="sm"
        >
          <AgModalContent>
            <div className="flex flex-col gap-4">
              <AgMoneyInput
                label="Cost basis"
                value={editValue != null ? Math.round(editValue * 100) : null}
                onChange={(cents) => setEditValue(cents != null ? cents / 100 : 0)}
              />
              <AgText size="14" color="secondary">
                Editing the cost basis for these products will change them in ALL pricing sheets.
              </AgText>
            </div>
          </AgModalContent>
          <AgModalActions>
            <AgButton
              variant="primary"
              onPress={() => {
                onSubmit();
                setIsEditing(false);
              }}
            >
              Save
            </AgButton>
          </AgModalActions>
        </AgModal>
      )}
    </>
  );
}
